import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  setPersistence, 
  browserLocalPersistence,
  onAuthStateChanged,
  signOut as firebaseSignOut
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
// Design Studio uploads rendered snapshots here rather than POSTing base64,
// which would blow past the serverless request body limit.
const storage = getStorage(app);

// Default is 120s of silent exponential backoff, which turns a misconfigured
// bucket into a two-minute hang on the submit button rather than a fast,
// recoverable failure. Design Studio races this with its own timeout too.
storage.maxUploadRetryTime = 6000;
storage.maxOperationRetryTime = 6000;

// Set persistent auth state
setPersistence(auth, browserLocalPersistence);

// Auth state observer
export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, (user) => {
    if (user) {
      // Get user's ID token for backend requests
      user.getIdToken().then((token) => {
        callback({ user, token });
      });
    } else {
      callback({ user: null, token: null });
    }
  });
};

// Sign out and clear auth state
export const signOut = async () => {
  try {
    await firebaseSignOut(auth);
    // Clear any auth-related local storage
    localStorage.removeItem('authUser');
    localStorage.removeItem('authToken');
  } catch (error) {
    console.error('Error signing out:', error);
    throw error;
  }
};

export { auth, db, storage };
